import i from "js-cookie";
const n = "login-required";
var s;
const c = (s = import.meta.env) == null ? void 0 : s.VITE_APP_NAME, m = 10 * 60 * 1e3;
function _(e) {
  const t = {
    path: "/",
    domain: `${import.meta.env.VITE_URL_BASE ? `.${import.meta.env.VITE_URL_BASE}` : "coactive.vagrant.switchsys.dev"}`,
    sameSite: "Strict",
    secure: !0
  };
  i.remove(n, t);
  let o = c;
  e != null && (o += `:${e.substring(1)}`);
  const r = new Date((/* @__PURE__ */ new Date()).getTime() + m);
  i.set(n, o, {
    expires: r,
    ...t
  });
}
export {
  _ as s
};
